import { render, staticRenderFns } from "./PermissionError.vue?vue&type=template&id=907f6780&scoped=true&"
import script from "./PermissionError.vue?vue&type=script&lang=js&"
export * from "./PermissionError.vue?vue&type=script&lang=js&"
import style0 from "./PermissionError.vue?vue&type=style&index=0&id=907f6780&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "907f6780",
  null
  
)

export default component.exports